// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Box, Flex, Text, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
// import wavehand from "../../assets/icons/wavehand.svg";
// import useRoleCheck from "../../hooks/useRoleCheck";
import useThemeColors from "../../hooks/useThemeColors";
// import logoText from "../../assets/icons/dentacasa-logo-text.svg";
import Tabs from "../shared/Tabs";
import MenuItems from "./MenuItems";
import { textSecondary } from "../../utils/colors";
// import { MdImageNotSupported } from "react-icons/md";
// import Onboarding from "../onboarding/Onboarding";
import dentacasa from "../../assets/icons/dentacasa.svg";
// import ChatBot from "../chatbot/Chatbot";
import logo from "../../assets/icons/dentacasa.svg";
import HeaderTenantSwitch from "./HeaderTenantSwitch";
import { useParams } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

const TenantSidebar = ({ userInfo, currentStep, tenant }) => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  // console.log("userInfo in sidebar", userInfo);

  const { whiteMode, newBorderMode, textPrimaryMode } = useThemeColors();

  // STATE

  // REDUX
  // const authLogin = useSelector((state) => state.authLogin);
  // const { userInfo } = authLogin;

  // const tenant = useSelector((state) => state.tenantDetailsBySlug.tenant);
  const clinicName = tenant?.clinicName || "";

  const handleTenantSwitch = (tenantSlug) => {
    const currentPath = location.pathname.split("/"); // Get current URL path
    currentPath[1] = tenantSlug; // Replace the slug part (index 1) with the new tenant slug
    const newPath = currentPath.join("/"); // Join the path back

    navigate(newPath); // Navigate to the new path with the updated slug
  };

  // ROLES
  // const isAdmin = useRoleCheck("admin");

  // const navigate = useNavigate();

  // const [onboardingOpen, setOnboardingOpen] = useState(false);
  // const [status, setStatus] = useState("incomplete");

  // REDUX
  // const dispatch = useDispatch();

  // const tenantDetails = useSelector((state) => state.tenantDetails);
  // const { tenant } = tenantDetails;

  // const tenantUpdateSetupStatus = useSelector(
  //   (state) => state.tenantUpdateSetupStatus
  // );
  // const {
  //   loading: loadingUpdateSetupStatus,
  //   success: successUpdateSetupStatus,
  //   error: errorUpdateSetupStatus,
  // } = tenantUpdateSetupStatus;

  // MENU ITEMS
  const menuItems = MenuItems({ userInfo, tenant });

  // HANDLERS

  // CUSTOM

  // USE EFFECT
  // useEffect(() => {
  //   if (tenant && tenant.onboarding) {
  //     setStatus(tenant.onboarding.status);
  //   }
  // }, [tenant, status]);

  // useEffect(() => {
  //   if (tenant && status === "incomplete") {
  //     setOnboardingOpen(true);
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     setOnboardingOpen(false);
  //     document.body.style.overflow = "auto";
  //   }
  // }, [tenant, status]);

  // LOGS
  console.log("tenant in sidebar", tenant);
  console.log("slug in sidebar", slug);
  console.log("userInfo in sidebar", userInfo);

  return (
    <>
      {/* <Onboarding
        tenant={tenant}
        open={onboardingOpen}
        setOpen={setOnboardingOpen}
      /> */}
      {/* <ChatBot /> */}
      <Box
        w={"280px"}
        transition="all 0.2s"
        borderRight={`0px solid ${newBorderMode}`}
        h="100vh"
        maxH="calc(100% - 0px)"
        bg={whiteMode}
        position="fixed"
        zIndex="1000"
      >
        <Flex
          w="100%"
          align="center"
          h="80px"
          p="0 0 0 2rem"
          borderBottom={`1px solid ${newBorderMode}`}
          overflow="hidden"
        >
          {!userInfo ? (
            <Flex mr="6rem">
              <Link to={`/`}>
                <Image src={logo} h="1.5rem" w="initial" />
              </Link>
            </Flex>
          ) : (
            <Flex display={["flex", "flex", "flex"]} align="center">
              <Flex
                justify="center"
                align="center"
                h="initial"
                w="280px"
                bg={whiteMode}
                // borderBottom={`1px solid ${newBorderMode}`}
              >
                <Box p="0rem 0rem 0rem 0rem" w="100%">
                  <HeaderTenantSwitch
                    slug={slug}
                    tenant={tenant}
                    clinicName={clinicName}
                    userInfo={userInfo}
                    handleTenantSwitch={handleTenantSwitch}
                  />
                </Box>
              </Flex>
              {/* <FormControlAIPrompt isDisabled /> */}
            </Flex>
          )}
        </Flex>

        {/* <Flex
          justify="center"
          align="center"
          h="5rem"
          w="100%"
          bg={whiteMode}
          borderBottom={`1px solid ${newBorderMode}`}
        >
          <Box p="0rem 0rem 0rem 2rem" w="100%">
            <Link to="/clinic-settings">
              <Flex align="center">
                {tenant && tenant.image ? (
                  <Flex
                    w="2.25rem"
                    h="2.25rem"
                    align="center"
                    justify="center"
                    borderRadius="0.75rem"
                    border={`0px solid ${newBorderMode}`}
                    overflow="hidden"
                    mr="0.5rem"
                    flexShrink="0"
                  >
                    <Image
                      src={tenant && tenant.image}
                      alt={tenant && tenant.clinicName}
                      w="100%"
                      h="100%"
                      objectFit="cover"
                    />
                  </Flex>
                ) : (
                  <Flex
                    w="2.25rem"
                    h="2.25rem"
                    align="center"
                    justify="center"
                    borderRadius="0.75rem"
                    border={`1px solid ${newBorderMode}`}
                    overflow="hidden"
                    mr="0.5rem"
                    flexShrink="0"
                  >
                    <Icon
                      as={MdImageNotSupported}
                      fontSize="1rem"
                      color={textPrimaryMode}
                    />
                  </Flex>
                )}

                <Flex gap={1}>
                  <Text
                    fontSize="sm"
                    fontWeight="500"
                    color={textPrimaryMode}
                    lineHeight="1.2"
                    maxW="10rem"
                  >
                    {tenant && tenant.clinicName}
                  </Text>
                </Flex>
              </Flex>
            </Link>
          </Box>
        </Flex> */}

        <Flex
          flexGrow="1"
          // h="calc(100% - 9rem)"
          h="calc(100% - 5rem)"
          p="0rem 0 0rem"
        >
          <Tabs.Container tabs={menuItems} />
        </Flex>
        {/* 
        {status === "incomplete" ||
          (status === "skipped" && (
            <Flex
              w="100%"
              position="absolute"
              bottom="5rem"
              left={0}
              align="center"
              justify="space-between"
              p="0 1.25rem"
              zIndex="100"
            >
              <Flex
                w="100%"
                position="relative"
                border={`0px solid ${newBorderMode}`}
                borderRadius="1rem"
                p="1.25rem 1rem"
                direction="column"
                bg="transparent"
                overflow="hidden"
                transition="all 0.2s "
                _hover={{
                  cursor: "pointer",
                  transform: "scale(1.02)",
                  border: `0px solid ${newBorderMode}`,
                }}
                onClick={() => {
                  // console.log("Clicked to open onboarding");
                  setOnboardingOpen(true);
                }}
              >
                <Flex
                  position="absolute"
                  w="100%"
                  h="100%"
                  top="0px"
                  left="0px;"
                  bg={whiteMode}
                  zIndex="-1"
                ></Flex>
                <Flex w="100%" h="100%" className="gradientbg2"></Flex>
                <Flex align="center" m="0rem 0 0rem">
                  <Image
                    src={wavehand}
                    alt="wavehand"
                    w="auto"
                    h="1.25rem"
                    mr={2}
                  />
                  <Text fontSize="sm" fontWeight="500" color={textPrimaryMode}>
                    {t("onboarding.finishSetup")}
                  </Text>
                </Flex>

                <Progress
                  mt="0.75rem"
                  value={currentStep && currentStep}
                  max={5}
                  size="xs"
                  className="attendeesTotal"
                  borderRadius="1rem"
                  w="100%"
                />
              </Flex>
            </Flex>
          ))} */}

        <Flex
          w="100%"
          position="absolute"
          bottom="0"
          left="0"
          direction="column"
          p="1rem 2rem 1rem"
          align="flex-start"
          justify="center"
          bg={whiteMode}
        >
          <Flex p="0 0 0.5rem">
            <NavLink to="/dashboard">
              <Image src={dentacasa} h="1.175rem" w="auto" />
              <Text
                fontSize="0.7rem"
                fontWeight="500"
                color={textSecondary}
                m="0.3rem 0 0"
              >
                Smile more. Worry less.
              </Text>
            </NavLink>
          </Flex>
        </Flex>
      </Box>
    </>
  );
};

export default TenantSidebar;
